import { makeStyles, styled } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

export const TotalItem = styled(Typography)({
  fontWeight: 600,
  display: 'flex',
  alignItems: 'center',
});

export const useStyles = makeStyles((theme) => ({
  gridContainer: {
    width: '100%',
    backgroundColor: '#fff',
    borderRadius: 4,
    boxShadow: '0 1px 0 0 rgba(0, 0, 0, 0.07)',
    marginBottom: theme.spacing(2),
  },
  divider: {
    height: 40,
  },
  exportContainer: {
    marginLeft: 'auto',
  },
  exportBtn: {
    padding: `0 ${theme.spacing(2)}px`,
    outline: 0,
    color: '#37474F',
  },
  tooltipIcon: {
    marginLeft: 4,
  },
}));
